import { useEffect, useMemo, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { type Container } from '@tsparticles/engine';
import { loadSlim } from '@tsparticles/slim';
import React from 'react';
import {
  subtleParticles,
  subtleParticlesMobile,
  interactiveParticles,
  interactiveParticlesMobile,
  starParticles,
  starParticlesMobile,
} from './particleConfigs';

interface ParticleBackgroundProps {
  className?: string;
  subtle?: boolean;
  star?: boolean;
}

const ParticleBackgroundComponent: React.FC<ParticleBackgroundProps> = ({
  className,
  subtle,
  star,
}) => {
  const [init, setInit] = useState(false);

  // this should be run only once per application lifetime
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 600;
  const options = useMemo(() => {
    let preset = '';
    let config;
    if (star) {
      if (isMobile) {
        preset = 'starParticlesMobile';
        config = starParticlesMobile;
      } else {
        preset = 'starParticles';
        config = starParticles;
      }
    } else if (subtle) {
      if (isMobile) {
        preset = 'subtleParticlesMobile';
        config = subtleParticlesMobile;
      } else {
        preset = 'subtleParticles';
        config = subtleParticles;
      }
    } else {
      if (isMobile) {
        preset = 'interactiveParticlesMobile';
        config = interactiveParticlesMobile;
      } else {
        preset = 'interactiveParticles';
        config = interactiveParticles;
      }
    }
    return config;
  }, [subtle, star, isMobile]);

  if (init) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      >
        <style>{`#tsparticles-bg-subtle { height: 100% !important; }`}</style>
        <Particles
          id={subtle ? 'tsparticles-bg-subtle' : 'tsparticles-bg'}
          className={className}
          options={options}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 0,
        pointerEvents: 'none',
        backgroundColor: 'transparent',
      }}
    />
  );
};

export const ParticleBackground = React.memo(ParticleBackgroundComponent);
